import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

// MUI Imports
import { useMediaQuery } from '@mui/material'

// Component Imports
import MailContent from '../../mailbox/MailContent'

import { getUrlParams } from '../../../services/urlServices'
import { getMessages, sendEmailReply } from '../../../services/B2BServices'
import { useToast } from '../../../../../campaigns/hooks/useToast'

const sortByDate = (arr, field, asc = true) => {
  return arr.sort((a, b) => asc
    ? (new Date(a?.[field]) - new Date(b?.[field]))
    : (new Date(b?.[field]) - new Date(a?.[field]))
  )
}

const getMessageObjExceptReplies = (message) => {
  return (({ replies, ...o }) => o)(message)
}

const getFlatMessages = (message, asc = true) => {
  let result = []
  result.push(getMessageObjExceptReplies(message))
  message?.replies?.length && message.replies.forEach((reply) => {
    const childFlat = getFlatMessages(reply)
    result = result.concat(childFlat)
  })

  return sortByDate(result, 'sentTimeMillis', asc)
}

const getManagedMessages = (arr) => {
  const flatted = arr?.map(item => getFlatMessages(item, false))
  const sortedFlatted = flatted.sort((a, b) => (new Date(b?.[0]?.sentTimeMillis) - new Date(a?.[0]?.sentTimeMillis)))

  return sortedFlatted
}

const Mailbox = () => {
  const { t } = useTranslation()

  const queryParams = getUrlParams()

  const { showSuccess, showError } = useToast()

  const b2bCampaignId = queryParams?.b2bCampaignId

  const [emailArrays, setEmailArrays] = useState([])
  const [activeEmailArr, setActiveEmailArr] = useState(null)
  const [fetching, setFetching] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  // Hooks
  const isBelowMdScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
  const isBelowSmScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))

  const getEmails = () => {
    if (b2bCampaignId) {
      setFetching(true)

      getMessages({ b2bCampaignId }).then((res) => {
        const managedMessages = getManagedMessages(res?.data)

        setEmailArrays(managedMessages)
      })
        .catch((err) => {
          err && showError(t('mailTemplate.mailbox.getMessagesErr'))
        })
        .finally(() => {
          setFetching(false)
        })
    }
  }

  const handleSubmitMail = (email, successCallback, replyMessageId = null) => {
    setSubmitting(true)

    const replyPayload = {
      campaignId: b2bCampaignId,
      to: email.to,
      cc: email.cc,
      subject: email.subject,
      bodyHtml: email.html,
      replyMessageId
    }

    sendEmailReply(replyPayload).then(() => {
      showSuccess(t('mailTemplate.mailbox.send.toastSuccess'))
      successCallback()
    }).catch((err) => {
      err && showError(t('mailTemplate.mailbox.send.toastErr'))
    }).finally(() => {
      setSubmitting(false)
    })
  }

  useEffect(() => {
    getEmails()
  }, [])

  return (
    <div className='flex is-full overflow-hidden rounded relative' style={{ height: 'calc(100vh - 280px)', minHeight: '400px' }}>
      <MailContent
        fetching={fetching}
        isBelowMdScreen={isBelowMdScreen}
        isBelowSmScreen={isBelowSmScreen}
        emailArrays={emailArrays}
        activeEmailArr={activeEmailArr}
        setActiveEmailArr={setActiveEmailArr}
        reloadMessages={getEmails}
        submitting={submitting}
        handleSubmitReply={handleSubmitMail}
        onSubmitNewMail={handleSubmitMail}
      />
    </div>
  )
}

export default Mailbox
